import { c as _c } from "react/compiler-runtime";
import type { BlindOffMessage } from '@module/types/centrifuge/public-message/blindMessageTypes';
interface Props {
  item: BlindOffMessage;
}
export default function BlindOffChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  const t0 = `${message.name}에 의해 ${message.type}블라인드가 해제되었습니다.`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="mb-[3px] whitespace-pre-wrap text-cht_al_2"><div>{t0}</div></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}